class ProductAiDisclaimer extends HTMLElement {
  connectedCallback() {
    // Relocating moves the node, which re-fires connectedCallback — guard so it runs once.
    if (this.relocated) return;
    this.relocated = true;
    this.#relocate();
  }

  #relocate() {
    const selector = this.dataset.target;
    if (!selector) return; // No target: stay at the bottom left of the product section.

    const section = this.closest('[data-section-type="product"]') || document;
    const target = section.querySelector(selector);
    if (!target || target === this || target.contains(this)) return;

    const position = this.dataset.position || 'append';

    switch (position) {
      case 'prepend':
        target.prepend(this);
        break;
      case 'insertBefore':
        target.parentNode?.insertBefore(this, target);
        break;
      case 'insertAfter':
        target.parentNode?.insertBefore(this, target.nextSibling);
        break;
      case 'append':
      default:
        target.append(this);
        break;
    }
  }
}

if (!customElements.get('product-ai-disclaimer')) {
  customElements.define('product-ai-disclaimer', ProductAiDisclaimer);
}